<template>
  <svg
    role="img"
    :aria-label="title"
    class="o-icon o-reddit-icon"
    viewBox="3 3 18 18"
    width="40"
    height="40"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21 11.0589C21 9.83693 19.988 8.84636 18.7396 8.84636C18.1143 8.84636 17.5495 9.09585 17.1404 9.49751C15.8763 8.69949 14.2614 8.19094 12.4877 8.1116C12.4888 7.37447 12.8261 6.68731 13.4136 6.22596C14.0022 5.76383 14.7624 5.59076 15.4987 5.75083L15.5998 5.7728C15.5988 5.79761 15.596 5.82193 15.596 5.84698C15.596 6.86703 16.4408 7.69395 17.4829 7.69395C18.525 7.69395 19.3698 6.86703 19.3698 5.84698C19.3698 4.82689 18.525 4 17.4829 4C16.8128 4 16.2258 4.34286 15.891 4.85813L15.7102 4.81881C14.6835 4.59551 13.6238 4.83693 12.8033 5.48124C11.9838 6.12477 11.5135 7.08335 11.5124 8.1116C9.73916 8.1909 8.12451 8.6992 6.86056 9.49685C6.45143 9.09512 5.88576 8.84632 5.2604 8.84632C4.01203 8.84636 3 9.83693 3 11.0589C3 11.9103 3.49219 12.6479 4.21251 13.0178C4.15781 13.2917 4.12903 13.5718 4.12903 13.8568C4.12903 17.036 7.65297 19.6133 12 19.6133C16.347 19.6133 19.8709 17.036 19.8709 13.8568C19.8709 13.5719 19.8422 13.292 19.7875 13.0182C20.5079 12.6483 21 11.9104 21 11.0589ZM17.4831 4.95483C17.9857 4.95483 18.3946 5.35509 18.3946 5.84712C18.3946 6.3391 17.9857 6.73936 17.4831 6.73936C16.9804 6.73936 16.5715 6.3391 16.5715 5.84712C16.5715 5.35509 16.9804 4.95483 17.4831 4.95483ZM3.97548 11.0587C3.97548 10.3652 4.55196 9.80089 5.26055 9.80089C5.56403 9.80089 5.84259 9.90495 6.06238 10.078C5.3749 10.6553 4.84266 11.3339 4.5122 12.079C4.18765 11.8509 3.97548 11.479 3.97548 11.0587ZM16.9817 17.1623C15.6625 18.127 13.8933 18.6584 11.9999 18.6584C10.1065 18.6584 8.33728 18.127 7.01812 17.1623C5.78399 16.2597 5.1043 15.0857 5.1043 13.8566C5.1043 12.6275 5.78399 11.4535 7.01812 10.551C8.33728 9.58618 10.1065 9.05484 11.9999 9.05484C13.8933 9.05484 15.6625 9.58618 16.9817 10.551C18.2158 11.4535 18.8955 12.6275 18.8955 13.8566C18.8955 15.0857 18.2158 16.2597 16.9817 17.1623ZM19.4875 12.0785C19.1569 11.3335 18.6247 10.655 17.9374 10.0778C18.1572 9.90478 18.4359 9.80089 18.7394 9.80089C19.448 9.80089 20.0245 10.3652 20.0245 11.0587C20.0244 11.479 19.812 11.8504 19.4875 12.0785Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.12491 13.5202C9.69333 13.5202 10.1541 13.0692 10.1541 12.5128C10.1541 11.9564 9.69333 11.5054 9.12491 11.5054C8.5565 11.5054 8.0957 11.9564 8.0957 12.5128C8.0957 13.0692 8.5565 13.5202 9.12491 13.5202Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8744 13.5197C15.4428 13.5197 15.9036 13.0687 15.9036 12.5123C15.9036 11.9559 15.4428 11.5049 14.8744 11.5049C14.306 11.5049 13.8452 11.9559 13.8452 12.5123C13.8452 13.0687 14.306 13.5197 14.8744 13.5197Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4392 14.9606C13.7136 15.6076 12.7731 15.9639 11.7908 15.9639C10.6878 15.9639 9.6658 15.5288 8.91319 14.7387C8.72954 14.5459 8.42095 14.5354 8.22395 14.7152C8.02694 14.8949 8.01618 15.197 8.19986 15.3898C9.12539 16.3614 10.4343 16.9186 11.7908 16.9186C13.0167 16.9186 14.1905 16.4738 15.0961 15.6663C15.2951 15.4887 15.3095 15.1868 15.1281 14.9919C14.9468 14.7972 14.6385 14.7829 14.4392 14.9606Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'RedditIcon',
  props: {
    title: {
      type: String,
      default: 'Reddit',
    },
  },
}
</script>
